-- | ---------------------------------------------------------------------------
-- | THIS FILE IS GENERATED -- DO NOT EDIT IT
-- | ---------------------------------------------------------------------------

module Elmish.HTML.Styled.Generated where

import Elmish.HTML.Generated as H
import Elmish.HTML.Internal as I


a = I.styledTag "a" :: I.StyledTag
a_ = I.styledTag_ "a" :: I.StyledTag_ H.Props_a

abbr = I.styledTag "abbr" :: I.StyledTag
abbr_ = I.styledTag_ "abbr" :: I.StyledTag_ H.Props_abbr

address = I.styledTag "address" :: I.StyledTag
address_ = I.styledTag_ "address" :: I.StyledTag_ H.Props_address

area = I.styledTagNoContent "area" :: I.StyledTagNoContent
area_ = I.styledTagNoContent_ "area" :: I.StyledTagNoContent_ H.Props_area

article = I.styledTag "article" :: I.StyledTag
article_ = I.styledTag_ "article" :: I.StyledTag_ H.Props_article

aside = I.styledTag "aside" :: I.StyledTag
aside_ = I.styledTag_ "aside" :: I.StyledTag_ H.Props_aside

audio = I.styledTag "audio" :: I.StyledTag
audio_ = I.styledTag_ "audio" :: I.StyledTag_ H.Props_audio

b = I.styledTag "b" :: I.StyledTag
b_ = I.styledTag_ "b" :: I.StyledTag_ H.Props_b

base = I.styledTagNoContent "base" :: I.StyledTagNoContent
base_ = I.styledTagNoContent_ "base" :: I.StyledTagNoContent_ H.Props_base

bdi = I.styledTag "bdi" :: I.StyledTag
bdi_ = I.styledTag_ "bdi" :: I.StyledTag_ H.Props_bdi

bdo = I.styledTag "bdo" :: I.StyledTag
bdo_ = I.styledTag_ "bdo" :: I.StyledTag_ H.Props_bdo

blockquote = I.styledTag "blockquote" :: I.StyledTag
blockquote_ = I.styledTag_ "blockquote" :: I.StyledTag_ H.Props_blockquote

body = I.styledTag "body" :: I.StyledTag
body_ = I.styledTag_ "body" :: I.StyledTag_ H.Props_body

br = I.styledTagNoContent "br" :: I.StyledTagNoContent
br_ = I.styledTagNoContent_ "br" :: I.StyledTagNoContent_ H.Props_br

button = I.styledTag "button" :: I.StyledTag
button_ = I.styledTag_ "button" :: I.StyledTag_ H.Props_button

canvas = I.styledTag "canvas" :: I.StyledTag
canvas_ = I.styledTag_ "canvas" :: I.StyledTag_ H.Props_canvas

caption = I.styledTag "caption" :: I.StyledTag
caption_ = I.styledTag_ "caption" :: I.StyledTag_ H.Props_caption

cite = I.styledTag "cite" :: I.StyledTag
cite_ = I.styledTag_ "cite" :: I.StyledTag_ H.Props_cite

code = I.styledTag "code" :: I.StyledTag
code_ = I.styledTag_ "code" :: I.StyledTag_ H.Props_code

col = I.styledTagNoContent "col" :: I.StyledTagNoContent
col_ = I.styledTagNoContent_ "col" :: I.StyledTagNoContent_ H.Props_col

colgroup = I.styledTag "colgroup" :: I.StyledTag
colgroup_ = I.styledTag_ "colgroup" :: I.StyledTag_ H.Props_colgroup

data' = I.styledTag "data" :: I.StyledTag
data'_ = I.styledTag_ "data" :: I.StyledTag_ H.Props_data

datalist = I.styledTag "datalist" :: I.StyledTag
datalist_ = I.styledTag_ "datalist" :: I.StyledTag_ H.Props_datalist

dd = I.styledTag "dd" :: I.StyledTag
dd_ = I.styledTag_ "dd" :: I.StyledTag_ H.Props_dd

del = I.styledTag "del" :: I.StyledTag
del_ = I.styledTag_ "del" :: I.StyledTag_ H.Props_del

details = I.styledTag "details" :: I.StyledTag
details_ = I.styledTag_ "details" :: I.StyledTag_ H.Props_details

dfn = I.styledTag "dfn" :: I.StyledTag
dfn_ = I.styledTag_ "dfn" :: I.StyledTag_ H.Props_dfn

dialog = I.styledTag "dialog" :: I.StyledTag
dialog_ = I.styledTag_ "dialog" :: I.StyledTag_ H.Props_dialog

div = I.styledTag "div" :: I.StyledTag
div_ = I.styledTag_ "div" :: I.StyledTag_ H.Props_div

dl = I.styledTag "dl" :: I.StyledTag
dl_ = I.styledTag_ "dl" :: I.StyledTag_ H.Props_dl

dt = I.styledTag "dt" :: I.StyledTag
dt_ = I.styledTag_ "dt" :: I.StyledTag_ H.Props_dt

em = I.styledTag "em" :: I.StyledTag
em_ = I.styledTag_ "em" :: I.StyledTag_ H.Props_em

embed = I.styledTagNoContent "embed" :: I.StyledTagNoContent
embed_ = I.styledTagNoContent_ "embed" :: I.StyledTagNoContent_ H.Props_embed

fieldset = I.styledTag "fieldset" :: I.StyledTag
fieldset_ = I.styledTag_ "fieldset" :: I.StyledTag_ H.Props_fieldset

figcaption = I.styledTag "figcaption" :: I.StyledTag
figcaption_ = I.styledTag_ "figcaption" :: I.StyledTag_ H.Props_figcaption

figure = I.styledTag "figure" :: I.StyledTag
figure_ = I.styledTag_ "figure" :: I.StyledTag_ H.Props_figure

footer = I.styledTag "footer" :: I.StyledTag
footer_ = I.styledTag_ "footer" :: I.StyledTag_ H.Props_footer

form = I.styledTag "form" :: I.StyledTag
form_ = I.styledTag_ "form" :: I.StyledTag_ H.Props_form

h1 = I.styledTag "h1" :: I.StyledTag
h1_ = I.styledTag_ "h1" :: I.StyledTag_ H.Props_h1

h2 = I.styledTag "h2" :: I.StyledTag
h2_ = I.styledTag_ "h2" :: I.StyledTag_ H.Props_h2

h3 = I.styledTag "h3" :: I.StyledTag
h3_ = I.styledTag_ "h3" :: I.StyledTag_ H.Props_h3

h4 = I.styledTag "h4" :: I.StyledTag
h4_ = I.styledTag_ "h4" :: I.StyledTag_ H.Props_h4

h5 = I.styledTag "h5" :: I.StyledTag
h5_ = I.styledTag_ "h5" :: I.StyledTag_ H.Props_h5

h6 = I.styledTag "h6" :: I.StyledTag
h6_ = I.styledTag_ "h6" :: I.StyledTag_ H.Props_h6

head = I.styledTag "head" :: I.StyledTag
head_ = I.styledTag_ "head" :: I.StyledTag_ H.Props_head

header = I.styledTag "header" :: I.StyledTag
header_ = I.styledTag_ "header" :: I.StyledTag_ H.Props_header

hgroup = I.styledTag "hgroup" :: I.StyledTag
hgroup_ = I.styledTag_ "hgroup" :: I.StyledTag_ H.Props_hgroup

hr = I.styledTagNoContent "hr" :: I.StyledTagNoContent
hr_ = I.styledTagNoContent_ "hr" :: I.StyledTagNoContent_ H.Props_hr

html = I.styledTag "html" :: I.StyledTag
html_ = I.styledTag_ "html" :: I.StyledTag_ H.Props_html

i = I.styledTag "i" :: I.StyledTag
i_ = I.styledTag_ "i" :: I.StyledTag_ H.Props_i

iframe = I.styledTag "iframe" :: I.StyledTag
iframe_ = I.styledTag_ "iframe" :: I.StyledTag_ H.Props_iframe

img = I.styledTagNoContent "img" :: I.StyledTagNoContent
img_ = I.styledTagNoContent_ "img" :: I.StyledTagNoContent_ H.Props_img

input = I.styledTagNoContent "input" :: I.StyledTagNoContent
input_ = I.styledTagNoContent_ "input" :: I.StyledTagNoContent_ H.Props_input

ins = I.styledTag "ins" :: I.StyledTag
ins_ = I.styledTag_ "ins" :: I.StyledTag_ H.Props_ins

kbd = I.styledTag "kbd" :: I.StyledTag
kbd_ = I.styledTag_ "kbd" :: I.StyledTag_ H.Props_kbd

keygen = I.styledTag "keygen" :: I.StyledTag
keygen_ = I.styledTag_ "keygen" :: I.StyledTag_ H.Props_keygen

label = I.styledTag "label" :: I.StyledTag
label_ = I.styledTag_ "label" :: I.StyledTag_ H.Props_label

legend = I.styledTag "legend" :: I.StyledTag
legend_ = I.styledTag_ "legend" :: I.StyledTag_ H.Props_legend

li = I.styledTag "li" :: I.StyledTag
li_ = I.styledTag_ "li" :: I.StyledTag_ H.Props_li

link = I.styledTagNoContent "link" :: I.StyledTagNoContent
link_ = I.styledTagNoContent_ "link" :: I.StyledTagNoContent_ H.Props_link

main = I.styledTag "main" :: I.StyledTag
main_ = I.styledTag_ "main" :: I.StyledTag_ H.Props_main

map = I.styledTag "map" :: I.StyledTag
map_ = I.styledTag_ "map" :: I.StyledTag_ H.Props_map

mark = I.styledTag "mark" :: I.StyledTag
mark_ = I.styledTag_ "mark" :: I.StyledTag_ H.Props_mark

math = I.styledTag "math" :: I.StyledTag
math_ = I.styledTag_ "math" :: I.StyledTag_ H.Props_math

menu = I.styledTag "menu" :: I.StyledTag
menu_ = I.styledTag_ "menu" :: I.StyledTag_ H.Props_menu

menuitem = I.styledTag "menuitem" :: I.StyledTag
menuitem_ = I.styledTag_ "menuitem" :: I.StyledTag_ H.Props_menuitem

meta = I.styledTagNoContent "meta" :: I.StyledTagNoContent
meta_ = I.styledTagNoContent_ "meta" :: I.StyledTagNoContent_ H.Props_meta

meter = I.styledTag "meter" :: I.StyledTag
meter_ = I.styledTag_ "meter" :: I.StyledTag_ H.Props_meter

nav = I.styledTag "nav" :: I.StyledTag
nav_ = I.styledTag_ "nav" :: I.StyledTag_ H.Props_nav

noscript = I.styledTag "noscript" :: I.StyledTag
noscript_ = I.styledTag_ "noscript" :: I.StyledTag_ H.Props_noscript

object = I.styledTag "object" :: I.StyledTag
object_ = I.styledTag_ "object" :: I.StyledTag_ H.Props_object

ol = I.styledTag "ol" :: I.StyledTag
ol_ = I.styledTag_ "ol" :: I.StyledTag_ H.Props_ol

optgroup = I.styledTag "optgroup" :: I.StyledTag
optgroup_ = I.styledTag_ "optgroup" :: I.StyledTag_ H.Props_optgroup

option = I.styledTag "option" :: I.StyledTag
option_ = I.styledTag_ "option" :: I.StyledTag_ H.Props_option

output = I.styledTag "output" :: I.StyledTag
output_ = I.styledTag_ "output" :: I.StyledTag_ H.Props_output

p = I.styledTag "p" :: I.StyledTag
p_ = I.styledTag_ "p" :: I.StyledTag_ H.Props_p

param = I.styledTagNoContent "param" :: I.StyledTagNoContent
param_ = I.styledTagNoContent_ "param" :: I.StyledTagNoContent_ H.Props_param

picture = I.styledTag "picture" :: I.StyledTag
picture_ = I.styledTag_ "picture" :: I.StyledTag_ H.Props_picture

pre = I.styledTag "pre" :: I.StyledTag
pre_ = I.styledTag_ "pre" :: I.StyledTag_ H.Props_pre

progress = I.styledTag "progress" :: I.StyledTag
progress_ = I.styledTag_ "progress" :: I.StyledTag_ H.Props_progress

q = I.styledTag "q" :: I.StyledTag
q_ = I.styledTag_ "q" :: I.StyledTag_ H.Props_q

rb = I.styledTag "rb" :: I.StyledTag
rb_ = I.styledTag_ "rb" :: I.StyledTag_ H.Props_rb

rp = I.styledTag "rp" :: I.StyledTag
rp_ = I.styledTag_ "rp" :: I.StyledTag_ H.Props_rp

rt = I.styledTag "rt" :: I.StyledTag
rt_ = I.styledTag_ "rt" :: I.StyledTag_ H.Props_rt

rtc = I.styledTag "rtc" :: I.StyledTag
rtc_ = I.styledTag_ "rtc" :: I.StyledTag_ H.Props_rtc

ruby = I.styledTag "ruby" :: I.StyledTag
ruby_ = I.styledTag_ "ruby" :: I.StyledTag_ H.Props_ruby

s = I.styledTag "s" :: I.StyledTag
s_ = I.styledTag_ "s" :: I.StyledTag_ H.Props_s

samp = I.styledTag "samp" :: I.StyledTag
samp_ = I.styledTag_ "samp" :: I.StyledTag_ H.Props_samp

script = I.styledTag "script" :: I.StyledTag
script_ = I.styledTag_ "script" :: I.StyledTag_ H.Props_script

section = I.styledTag "section" :: I.StyledTag
section_ = I.styledTag_ "section" :: I.StyledTag_ H.Props_section

select = I.styledTag "select" :: I.StyledTag
select_ = I.styledTag_ "select" :: I.StyledTag_ H.Props_select

slot = I.styledTag "slot" :: I.StyledTag
slot_ = I.styledTag_ "slot" :: I.StyledTag_ H.Props_slot

small = I.styledTag "small" :: I.StyledTag
small_ = I.styledTag_ "small" :: I.StyledTag_ H.Props_small

source = I.styledTagNoContent "source" :: I.StyledTagNoContent
source_ = I.styledTagNoContent_ "source" :: I.StyledTagNoContent_ H.Props_source

span = I.styledTag "span" :: I.StyledTag
span_ = I.styledTag_ "span" :: I.StyledTag_ H.Props_span

strong = I.styledTag "strong" :: I.StyledTag
strong_ = I.styledTag_ "strong" :: I.StyledTag_ H.Props_strong

style = I.styledTag "style" :: I.StyledTag
style_ = I.styledTag_ "style" :: I.StyledTag_ H.Props_style

sub = I.styledTag "sub" :: I.StyledTag
sub_ = I.styledTag_ "sub" :: I.StyledTag_ H.Props_sub

summary = I.styledTag "summary" :: I.StyledTag
summary_ = I.styledTag_ "summary" :: I.StyledTag_ H.Props_summary

sup = I.styledTag "sup" :: I.StyledTag
sup_ = I.styledTag_ "sup" :: I.StyledTag_ H.Props_sup

svg = I.styledTag "svg" :: I.StyledTag
svg_ = I.styledTag_ "svg" :: I.StyledTag_ H.Props_svg

table = I.styledTag "table" :: I.StyledTag
table_ = I.styledTag_ "table" :: I.StyledTag_ H.Props_table

tbody = I.styledTag "tbody" :: I.StyledTag
tbody_ = I.styledTag_ "tbody" :: I.StyledTag_ H.Props_tbody

td = I.styledTag "td" :: I.StyledTag
td_ = I.styledTag_ "td" :: I.StyledTag_ H.Props_td

template = I.styledTag "template" :: I.StyledTag
template_ = I.styledTag_ "template" :: I.StyledTag_ H.Props_template

textarea = I.styledTagNoContent "textarea" :: I.StyledTagNoContent
textarea_ = I.styledTagNoContent_ "textarea" :: I.StyledTagNoContent_ H.Props_textarea

tfoot = I.styledTag "tfoot" :: I.StyledTag
tfoot_ = I.styledTag_ "tfoot" :: I.StyledTag_ H.Props_tfoot

th = I.styledTag "th" :: I.StyledTag
th_ = I.styledTag_ "th" :: I.StyledTag_ H.Props_th

thead = I.styledTag "thead" :: I.StyledTag
thead_ = I.styledTag_ "thead" :: I.StyledTag_ H.Props_thead

time = I.styledTag "time" :: I.StyledTag
time_ = I.styledTag_ "time" :: I.StyledTag_ H.Props_time

title = I.styledTag "title" :: I.StyledTag
title_ = I.styledTag_ "title" :: I.StyledTag_ H.Props_title

tr = I.styledTag "tr" :: I.StyledTag
tr_ = I.styledTag_ "tr" :: I.StyledTag_ H.Props_tr

track = I.styledTagNoContent "track" :: I.StyledTagNoContent
track_ = I.styledTagNoContent_ "track" :: I.StyledTagNoContent_ H.Props_track

u = I.styledTag "u" :: I.StyledTag
u_ = I.styledTag_ "u" :: I.StyledTag_ H.Props_u

ul = I.styledTag "ul" :: I.StyledTag
ul_ = I.styledTag_ "ul" :: I.StyledTag_ H.Props_ul

var = I.styledTag "var" :: I.StyledTag
var_ = I.styledTag_ "var" :: I.StyledTag_ H.Props_var

video = I.styledTag "video" :: I.StyledTag
video_ = I.styledTag_ "video" :: I.StyledTag_ H.Props_video

wbr = I.styledTagNoContent "wbr" :: I.StyledTagNoContent
wbr_ = I.styledTagNoContent_ "wbr" :: I.StyledTagNoContent_ H.Props_wbr
